/**
 * Helpers to escape dangerous character from a string.
 * Dangerous characters ar <>&'"
 * taken from https://www.php.net/manual/en/function.htmlspecialchars.php
 *
 * @param {string} text
 * @returns string
 */
export function escapeHtml(text) {
  const map = {
    "&": "and",
    "<": "lt",
    ">": "gt",
    '"': "doublequote",
    "'": "quote"
  };

  return text
    .replace(/[&<>"']/g, function (m) {
      return map[m];
    })
    .replace(/\\r\n|\\n|\\r+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Helpers to sanitize every string values in an array or object
 *
 * @param {array | object} obj
 * @returns
 */
export function sanitizeObjectStringValues(obj) {
  if (obj === null) return;

  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === "string") {
      obj[key] = escapeHtml(obj[key]);
    } else if (typeof obj[key] === "object") {
      sanitizeObjectStringValues(obj[key]);
    }
  });

  return obj;
}
